import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';
import { handleResponseError } from '../../utils/helpers/error';

export const getMails = createAsyncThunk('mails.getMails', async ({ }, { rejectWithValue }) => {
  try {
    const { data: { emails } } = await api.mails.getMails();
    return emails;
  } catch (error) {
    handleResponseError(error);
    return rejectWithValue();
  }
});

export const addMail = createAsyncThunk('mails.addMail', async ({
  email, onSuccess, onError,
}, { rejectWithValue }) => {
  try {
    const { data: { newMail, message } } = await api.mails.addMail(email);
    onSuccess(message);
    return newMail;
  } catch (error) {
    handleResponseError(error, onError);
    return rejectWithValue();
  }
});

export const updateMail = createAsyncThunk('mails.updateMail', async ({
  id, email, onSuccess, onError,
}, { rejectWithValue }) => {
  try {
    const { data: { message } } = await api.mails.updateMail(id, email);
    onSuccess(message);
    return {
      _id: id,
      email,
    };
  } catch (error) {
    handleResponseError(error, onError);
    return rejectWithValue();
  }
});

export const deleteMail = createAsyncThunk('mails.deleteMail', async ({
  id, onSuccess, onError,
}, { rejectWithValue }) => {
  try {
    const { data: { message } } = await api.mails.deleteMail(id);
    onSuccess(message);
    return id;
  } catch (error) {
    handleResponseError(error, onError);
    return rejectWithValue();
  }
});
